import { customAxios } from './customAxios'
export function getFoldersTree(idNodoPratica, idDocumento = null) {
  const config = {
    headers: {
      Accept: '*/*',
      AuthToken: JSON.parse(localStorage.getItem('token')),
    },
  }

  let params = new URLSearchParams()
  params.append('idNodoPratica', idNodoPratica)
  if (idDocumento !== null) {
    params.append('idDocumento', idDocumento)
  }

  const getFoldersTreeRequest = customAxios
    .get(
      `${process.env.REACT_APP_BACKEND_HOST}/${
        process.env.REACT_APP_PATH_NEW_PREFIX
      }/getFoldersTree?${params.toString()}`,
      config,
    )
    .then(response => response.data.body)
  return getFoldersTreeRequest
}
